import { StyledWidgetItem } from './style';

import type React from 'react';

type Props = {
  count: number | string;
  label: string;
  linkLabel?: string;
  linkTarget?: string;
};

export const WidgetItem: React.FC<Props> = ({ count, label }) => (
  <StyledWidgetItem>
    <p className="count-of-properties">{count}</p>
    <p className="label">{label}</p>
  </StyledWidgetItem>
);
